import { ReactNode, useRef } from 'react';
import { FormScrollContext } from './FormScrollContext';

interface Props {
  children: ReactNode;
}

export function FormScrollProvider({ children }: Props) {
  const scrollView = useRef<HTMLDivElement>(null);
  return <FormScrollContext.Provider value={scrollView}>{children}</FormScrollContext.Provider>;
}
